const buttonStyling = `
  border border-primary rounded-lg cursor-pointer hover:bg-primary hover:text-white transition duration-300 ease-in-out
  `

const Styling = {
  'sizes': {
    'hero': {
      'default': 'text-5xl leading-tight tracking-tight font-bold font-sans',
    },
    'heading1': {
      'default': 'text-2xl md:text-3xl leading-tight tracking-tight font-medium font-sans',
    },
    'heading2': {
      'default': 'text-xl md:text-2xl leading-snug tracking-tight font-medium font-sans ',
    },
    'heading3': {
      'default': 'text-xl leading-snug tracking-normal font-medium font-sans',
    },
    'heading4': {
      'default': 'text-md leading-snug tracking-normal font-bold font-sans',
    },
    'emphasize': {
      'default': 'text-lg leading-snug tracking-wide font-serif',
      'strong': 'text-lg leading-snug tracking-wide font-medium font-serif',
    },
    'body': {
      'default': 'text-base leading-snug tracking-normal font-serif',
      'strong': 'text-base leading-snug tracking-normal font-medium font-serif',
    },
    'wide': {
      'default': 'text-sm leading-normal tracking-widest font-sans',
      'strong': 'text-sm leading-normal tracking-widest font-medium font-sans',
    },
    'sm': {
      'default': 'text-sm',
      'strong': 'text-sm font-medium'
    },
    'xs': {
      'default': 'text-xs',
      'strong': 'text-xs font-medium',
    },
    'xsWide': {
      'default': 'text-xs tracking-widest',
      'strong': 'text-xs tracking-widest font-medium ',
    },
  },
  'buttons': {
    'sm': {
      'primary': {
        'default': `${buttonStyling} bg-primary-800 text-white py-2 px-4 text-center`
      },
      'secondary': {
        'default': `${buttonStyling} bg-secondary-800 text-white py-2 px-4 text-center`
      }
    }
  },
  'backgrounds': {
    'dark': 'bg-primary-900',
    'light': 'bg-primary-50',
    'base': 'bg-primary/5',
  }
}

export default Styling;